import { colors } from '../../colors';
var para = {
  messageColor: colors.clearBlue
};
export default para;